export default __webpack_public_path__ + "static/media/portfolio-cia-1.0ebb01b1.jpg";